<template>
    <el-form :model="newsData" :rules="validateRules" ref="newsForm" label-width="100px">
        <el-form-item label="标题" prop="newsContentTitle">
            <el-input v-model="newsData.newsContentTitle" auto-complete="off" placeholder="线索标题（必填）"></el-input>
        </el-form-item>
        <el-form-item label="来源" prop="newsContentSource">
            <el-input v-model="newsData.newsContentSource" auto-complete="off" placeholder="线索来源（必填）"></el-input>
        </el-form-item>
        <el-form-item class="yd-xiansuo-long-words" label="封皮图片（尺寸2:1）" prop="newsContentImage" style="margin-bottom:16px;">
            <el-input v-model="newsData.newsContentImage" auto-complete="off" placeholder="图片链接（必填）"></el-input>
        </el-form-item>
        <el-form-item class="yd-select-project" label="选择项目" style="margin-bottom:40px;">
            <el-select v-model="newsData.newsContentURL" prop="newsContentURL"  placeholder="请选择">
                <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-if="isEdit" label="置顶权重"  prop="newsContentIsTop">
            <el-input v-model="newsData.newsContentIsTop" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button-group>
                <el-button type="success" @click="newsFormSubmit">提交</el-button>
                <el-button v-if="addForm" @click="newsFormReset">重置</el-button>
                <el-button v-else @click="newsFormCancle">取消</el-button>
            </el-button-group>
        </el-form-item>
    </el-form>
</template>
<script>
export default {
    props: ["newsData", "addForm", "projectList", "isEdit"],
    data() {
        return {
            validateRules: {
                newsContentTitle: [
                    { required: true, message: '请填写新闻标题', trigger: 'blur' }
                ],
                newsContentSource: [
                    { required: true, message: '请填写新闻来源', trigger: 'blur' }
                ],
                newsContentURL: [
                    { required: true, message: '请选择项目', trigger: 'blur' }
                ],
                newsContentImage: [
                    { required: true, message: '请填写图片地址', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        newsFormCancle() {
            this.$emit('newsFormCancle');
        },
        newsFormSubmit() {
            let flag = true;
            this.$refs.newsForm.validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$emit('newsFormSubmit', this.newsData, this.addForm);
        },
        newsFormReset() {
            this.$refs.newsForm.resetFields();
            this.newsData.newsContentURL = "";
        }
    }
}
</script>
<style lang="less">
.yd-xiansuo-long-words {
    .el-form-item__error {
        top: 84%;
    }
    .el-form-item__label {
        padding-top: 4px;
    }
}
.yd-select-project {
    text-align: left;
}
</style>




// WEBPACK FOOTER //
// CollectNews.vue?66ba9fa3